/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bland_Loud_Mantis_ZapInputs */

const fr_bland_loud_mantis_zap = /** @type {(inputs: Bland_Loud_Mantis_ZapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu viens d'arriver, aucun mot de passe n'a été crée`)
};

/**

* @param {Bland_Loud_Mantis_ZapInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const bland_loud_mantis_zap = /** @type {((inputs?: Bland_Loud_Mantis_ZapInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bland_Loud_Mantis_ZapInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_bland_loud_mantis_zap(inputs)
});